const invertedMessages = {
  'You can now configure user modification workflow to include ID proofing workflow stage.':
    'external.idp.enabled.successText',
  'Data Fetch Error': 'external.idp.dataError',
  'ID Proofing configuration Action failed, please try again later.':
    'external.idp.dataError.message',
  'ID Proofing': 'external.idp.idProofing',
  'Settings have been updated successfully.': 'external.idp.save.successText',
  'Configured Providers': 'external.idp.configuredProviders',
  'Available Providers': 'external.idp.availableProviders',
  Providers: 'external.idp.tab.providers',
  Settings: 'external.idp.tab.settings',
};

export default invertedMessages;
